import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import KeyValueInput from '../../../../Common/Utils/KeyValueInput';
import ConfirmDeleteIcon from '../../../../Common/Buttons/ConfirmDeleteIcon';

const styles = createStyles({
  fields: {
    width: '90%'
  }
});

type Props = {
  classes: any,
  handleRemove: any,
  index: number,
  item: string,
  record: any
};

const Property = (props: Props) => (
  <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', padding: 25 }}>
    <Field name={`${props.item}.required`} source={`${props.item}.required`} component={BooleanInput} label="Required" style={{ width: '0' }} />

    <div style={{ display: 'flex', width: '90%' }}>
      <div style={{ flex: '1' }}>
        <Field name={`${props.item}.name`} source={`${props.item}.name`} component={TextInput} label="Name" className={props.classes.fields} /><br />
      </div>
      <div style={{ flex: '1' }}>
        <Field name={`${props.item}.value`} source={`${props.item}.value`} component={TextInput} label="Value" className={props.classes.fields} /><br />
      </div>
    </div>

    <Field name={`${props.item}.description`} source={`${props.item}.description`} component={TextInput} label="Description" className={props.classes.fields} /><br /><br />

    <FieldArray name={`${props.item}.options`} baseName={`${props.item}.options`} component={KeyValueInput} containerWidth="70%" mainLabel="Options" addItemLabel="Add Ad Property Option" />

    <div style={{ width: '100%', textAlign: 'right' }}>
      <ConfirmDeleteIcon onClick={(event) => props.handleRemove(event, props.index)} />
    </div>
  </div>
);

export default withStyles(styles)(Property);



// WEBPACK FOOTER //
// ./src/views/Components/Managed/PropertyGroups/Partials/Property.tsx